import JobsDetails from './JobOfferDetails';

export default JobsDetails;
